import React from 'react';
import SearchBar from '../Component/SearchBar';

const Home: React.FC = () => {
  return (
    <div>
      <SearchBar />
    </div>
  );
};

export default Home;
